import { render } from "./AddAddress.vue?vue&type=template&id=02cf1cf3&scoped=true"
import script from "./AddAddress.vue?vue&type=script&lang=js"
export * from "./AddAddress.vue?vue&type=script&lang=js"

import "./AddAddress.vue?vue&type=style&index=0&id=02cf1cf3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02cf1cf3"]])

export default __exports__